import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';
import moment, { parseTwoDigitYear } from 'moment';
import { iAxios } from '../../lib/utils';
import { Spinner } from '../common/Helper';
import { Month, LinearMonth } from '../common/Calendar';
import { useSelector } from 'react-redux';
import Icon from '../ds/Icon';

const Leaves = (props) => {

    const userFilter = useSelector(st => st.tickets.userFilter);

    const [search, setSearch] = useState("");
    const [category, setCategory] = useState("all");
    const [responseList, setResponse] = useState(null);
    const [catList, setCatList] = useState([]);
    const [months, setMonths] = useState([]);
    const [people, setPeople] = useState([]);
    const [filteredItems, setFiltered] = useState(null)
    const dbSetSearch = debounce(setSearch, 200);

    useEffect(() => {
        setResponse([]);
        iAxios.get(`/api/v1/utils/leaves`).then(resp => {
            const data = resp.data.data;
            const list = data.sort((a, b) => {
                return moment(a.dueDate).toDate().getTime() - moment(b.dueDate).toDate().getTime();
            });
            list.reverse();
            const cList = data.reduce((agg, item) => {
                if (!agg.includes(item.category)) {
                    agg.push(item.category); 
                }
                return agg;
            }, [])
            cList.sort();
            setCatList(cList);
            setResponse(list);
        }).catch(ex => {
            console.error(ex);
        });
    }, [1])


    useEffect(() => {


        if (!responseList) {
            return;
        }
        const userMap = userFilter.reduce((agg, item) => {
            agg[item.email] = true;
            return agg;
        }, {})

        const filtered = responseList.filter(item => {

            if (search === '' && !userMap[item.assigneeUser?.email]) {
                return false;
            }

            if (category !== 'all' && category !== item.category) {
                return false;
            }

            if (search !== '') {
                const str = search.toLowerCase();
                if (str === 'none') {
                    console.log(item.assigneeUser);
                    return item.assigneeUser == null;
                }

                return item.assigneeUser?.email.indexOf(str) >= 0 ||
                    item.url.indexOf(search) >= 0 ||
                    item.title.toLowerCase().indexOf(str) >= 0
            }
            return true;
        });
        const months = filtered.reduce((agg, item) => {
            let duration = item.timeEstimate / (60 * 60);
            let date = moment(item.dueDate);

            while (duration > 0) {
                const monYr = date.startOf('mon');
                const mon = monYr.format('YYYY-MM-01');
                const day = date.format('ddd');
                if (day === 'Sun' || day === 'Sat') {
                    date.add(1, 'day');
                    continue;
                }

                if (!agg[mon]) {
                    agg[mon] = []
                }
                agg[mon].push({
                    id: item.id,
                    duration: item.timeEstimate,
                    date: date.format('YYYY-MM-DD'),
                    url:item.url,
                    title: item.assigneeUser?.email 
                });
                duration -= 8;
                date.add(1, 'day');
            }
            return agg;
        }, {})

        const people = filtered.reduce((agg, item) => {
            if (!item.assigneeUser) {
                return agg;
            }
            if (!agg[item.assigneeUser.name]) {
                agg[item.assigneeUser.name] = 0
            }
            agg[item.assigneeUser.name] += Math.floor(item.timeEstimate / (3600 * 8))
            return agg;
        }, {})
        setPeople(people);
        setMonths(months);
        setFiltered(filtered);
    }, [responseList, search, category, userFilter])

    return <div>
        {!props.embedded && <div className="page-head"><h2>Leaves</h2></div>}

        <div className="ds-field-row">
            <input className="ds-input ds-field" placeholder="Search by name, title or URL…" onChange={e => dbSetSearch(e.target.value)} />
            <select className="ds-select" style={{ maxWidth: '220px' }} onChange={e => setCategory(e.target.value)} aria-label="Category">
                <option value="all">All categories</option>
                {catList.map(item => (<option key={item} value={item}>{item}</option>))}
            </select>
        </div>

        <div className="ds-panel" style={{ padding: 'var(--ds-space-3)', marginBottom: 'var(--ds-space-5)' }}>
            <div className="scroll-x">
                <LinearMonth months={months} />
            </div>
        </div>
        <div style={{ display: 'none', flexWrap: 'wrap' }}>
            {Object.keys(months).map(mon =>
                <div key={mon} style={{ display: 'flex' }}>
                    <Month mon={mon} data={months[mon]} />
                </div>
            )}
        </div>

        <div className="split-main">
            <div className="ds-panel">
                <div className="ds-table-wrap">
                    <table className="ds-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th style={{ minWidth: '100px' }}>Date</th>
                                <th>User</th>
                                <th>Days</th>
                                <th>Approver</th>
                                <th>Info</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredItems && filteredItems.map((item, idx) => (
                                <tr key={item.id || idx}>
                                    <td className="ds-nums">{idx + 1}</td>
                                    <td className="ds-nums" style={{ textAlign: "right" }}>{moment(item.dueDate).format('MMM-DD')}</td>
                                    <td>{item.assigneeUser?.email}</td>
                                    <td className="ds-nums">{item.timeEstimate ? item.timeEstimate / (8 * 3600) : 'not marked'}</td>
                                    <td>{item.approver ? item.approver?.email : 'Not approved'}</td>
                                    <td>
                                        <a target="_blank" rel="noreferrer" href={item.url}>
                                            {item.title}
                                            {item.dueDate == null && (
                                                <span className="team-alert is-critical" title="Date not marked" style={{ marginLeft: '6px' }}>
                                                    <Icon name="alert" title="Date not marked" />
                                                </span>
                                            )}
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filteredItems === null && <Spinner />}
                </div>
            </div>

            <div className="ds-panel">
                <div className="ds-panel__head"><h3 className="ds-panel__title">By person</h3></div>
                <div className="ds-table-wrap">
                    <table className="ds-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>User</th>
                                <th>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.keys(people).sort().map((name, idx) => (
                                <tr key={name}>
                                    <td className="ds-nums">{idx + 1}</td>
                                    <td>{name}</td>
                                    <td className="ds-nums">{people[name]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>;
}

export default Leaves;